import React from 'react';
import { Redirect, useParams } from 'react-router-dom';
import PropTypes from 'prop-types';

import { Loading } from 'uikit/loaders';

import { useGlobalQueries } from '@/exceed';

import getFirstAccessibleOrganizationForUser from '../helpers/getFirstAccessibleOrganizationForUser';

import useOrganizationVideoPermissions from '../hooks/useOrganizationVideoPermissions';
import useVideoVersion from '../hooks/useVideoVersion';

import VideosAdminBodyContainer from './videosAdminBodyContainer';
import VideosAdminHeaderContainer from './videosAdminHeaderContainer';

import styles from '../styles/videosAdmin.module.scss';

const VideosAdminContainer = ({ isEditRoute = false, isTopicsRoute = false }) => {
  const organizationPermissions = useOrganizationVideoPermissions({ isEnabled: true });
  const globalQueries = useGlobalQueries();
  const { organizations } = globalQueries;
  const { orgId } = useParams();
  const isVideoVersionEnabled = isEditRoute && !isTopicsRoute;
  const { videoVersion, videoVersionKey } = useVideoVersion({ isEnabled: isVideoVersionEnabled });

  const isLoadingOrgs = [organizationPermissions, organizations].some(
    (prop) => prop.status !== 'success',
  );

  const isLoadingDetail = isVideoVersionEnabled && videoVersion.isLoading;

  if (isLoadingOrgs || isLoadingDetail) return <Loading className={styles.loader} />;

  if (!orgId) {
    const defaultOrgId = getFirstAccessibleOrganizationForUser({
      ...globalQueries,
      organizationPermissions,
    });

    return <Redirect to={`/videos/organizations/${defaultOrgId}/on-demand`} />;
  }

  return (
    <>
      <VideosAdminHeaderContainer isDetailsPage={isEditRoute} isTopicsPage={isTopicsRoute} />
      <VideosAdminBodyContainer
        isHomePage={!isEditRoute}
        isTopicsPage={isTopicsRoute}
        videoVersion={videoVersion}
        videoVersionKey={videoVersionKey}
      />
    </>
  );
};

VideosAdminContainer.propTypes = {
  isEditRoute: PropTypes.bool,
  isTopicsRoute: PropTypes.bool,
};

export default VideosAdminContainer;
